import { ReactElement, ReactNode } from 'react'
import { Stack, Typography } from '@mui/material'

interface Props {
  title: string
  children: ReactNode
}

/** One column of the project form: a small caption over its fields. */
const FieldGroup = ({ title, children }: Props): ReactElement => (
  <Stack direction="column" spacing={1} sx={{ flex: 1, minWidth: 0 }}>
    <Typography
      variant="overline"
      color="text.secondary"
      sx={{ fontWeight: 600, lineHeight: 1.5, letterSpacing: 0.8 }}
    >
      {title}
    </Typography>
    {children}
  </Stack>
)

export default FieldGroup
